import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import banner from '../../assets/images/banner.jpg';
import axios from 'axios';
export default function Invite({
  open,
  setOpen,
  loading,
  setLoading,
  email,
  project_id,
  setOpenSnack,
  member_id,
  email1,
  email2,
  email3,
  email1valid,
  email2valid,
  email3valid,
  setEmail1,
  setEmail2,
  setEmail3,
  setEmail1valid,
  setEmail2valid,
  setEmail3valid,
  agegroup,
  gender,
  company_name,
}) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleEmail1 = (e) => {
    setEmail1(e.target.value);
    setEmail1valid(emailRegex?.test(email1));
  };
  const handleEmail2 = (e) => {
    setEmail2(e.target.value);
    setEmail2valid(emailRegex?.test(email2));
  };
  const handleEmail3 = (e) => {
    setEmail3(e.target.value);
    setEmail3valid(emailRegex?.test(email3));
  };
  const handleClose = () => {
    setOpen(false);
    setLoading(false);
  };
  console.log('final', {
    refer_email1: email1,
    refer_email2: email2,
    refer_email3: email3,
    project_id,
    agegroup,
    gender,
    company_name,
    email,
    member_id,
  });
  const handleClick = async () => {
    setLoading(true);
    await axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/reports/sendIndividualReportLink`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: {
        member_id,
        project_id,
        email,
        refer_email1: email1,
        refer_email2: email2,
        refer_email3: email3,
        agegroup,
        gender,
        company_name,
      },
    })
      .then(function (response) {
        console.log(response);
        setLoading(false);
        // window.location.reload();
        setOpenSnack(true);
        setTimeout(() => {
          setOpen(false);
          setEmail1('');
          setEmail2('');
          setEmail3('');
        }, 2000);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  console.log('emails', email1, email2, email3);
  return (
    <Dialog
      onClose={handleClose}
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          minWidth: '80vw',
        },
      }}
      open={open}
      className="filter-dialog"
    >
      <Box>
        <img src={banner} alt="" />
      </Box>
      <Box className="p-8">
        <Typography variant="h5" className="text-center !font-bold">
          Invite up to three friends to complete the survey by entering their
          email address below...
        </Typography>
      </Box>
      <div className="flex flex-col p-8">
        <div className="flex space-x-4 mb-8 justify-center">
          <TextField
            label="Enter your friend email address"
            fullWidth
            onChange={handleEmail1}
            className="border-x-4"
            variant="outlined"
            sx={{
              '& fieldset': { borderWidth: '3px' },
            }}
          />
          <TextField
            label="Enter your friend email address"
            fullWidth
            onChange={handleEmail2}
            className="border-x-4"
            variant="outlined"
            sx={{
              '& fieldset': { borderWidth: '3px' },
            }}
          />
          <TextField
            label="Enter your friend email address"
            fullWidth
            className="border-x-4"
            variant="outlined"
            onChange={handleEmail3}
            sx={{
              '& fieldset': { borderWidth: '3px' },
            }}
          />
        </div>
        <Button
          variant="contained"
          endIcon={loading && <CircularProgress size={'20px'} />}
          color="primary"
          className="!mt-12 mb-4 w-max flex self-end"
          style={{
            backgroundColor: '#D0ECE6',
            color: '#000',
            pointerEvents: loading ? 'none' : 'auto',
          }}
          sx={{
            fontSize: '16px',
            fontWeight: 500,
            padding: '8px 30px',
            textTransform: 'capitalize',
            color: '#000',
            backgroundColor: '#D0ECE6',
            '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
              backgroundColor: '#D0ECE6',
            },
          }}
          onClick={handleClick}
        >
          Send an invitation
        </Button>
      </div>
    </Dialog>
  );
}
